import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import router from "@/router";
import { getToken, removeToken } from "@/utils/auth";

// axios
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 15000
});

// request
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      if (config.url === "/api-uaa/oauth/user/reg/token/phone2") {
        config.headers["client_id"] = "app";
        config.headers["client_secret"] = "app";
      } else if (config.url === "/api-uaa/oauth/user/reg/token/phoneTwin") {
        config.headers["client_id"] = "app";
        config.headers["client_secret"] = "app";
      } else {
        // const s =
        //   "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MzEwMTU2NjMsInVzZXJfbmFtZSI6IjE4MDQ5NTczMDQxIiwianRpIjoiNmE2MWZiMWUtY2JlZC00M2Q1LWEyYjQtZjM5MDA4ZmY3NTA0IiwiY2xpZW50X2lkIjoiYXBwIiwic2NvcGUiOlsiYXBwIl19.XUDh0Ms1Ftw_MU4EM2Dnq9dldU_X_TEuZRFR7HLybkfJSi2RqhBCIJGDvnQkv4KwZ-TYiRpnMI5vLI9p1BXg3G0JrEYHfzgVXiHauHM6ppRX3yCR-kDvQvroYczp9MJYNii0WuDSxOh-vFqf2-q70nlwDTWhV9ZR5fvdarHTiGnDQYtl_CO7Y__JwBAe6zjWXLhgvP_WW_OxS8GNBhtPBzp2xd3CzeoGnSALQbr1VrGJEIxtGs4YIwE1qZwvsKIOcdGSgbaw1ahhVjSe8zTOZmDh-guFBMq6WasrcMdVhTsmHgX6T_xQszHY77Cd3-cDr3vsl2UN3hWFvM9w11drTQ";
        let test = config.data;
        if (test) {
          config.data["access_token"] = getToken();
        }
        if (getToken() && !config.ignoreToken) {
          config.headers["Authorization"] = "bearer " + getToken();
        }
      }
    } else {
      config.headers["client_id"] = "app";
      config.headers["client_secret"] = "app";
      if (getToken() && !config.ignoreToken) {
        config.headers["Authorization"] = "bearer " + getToken();
      }
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// respone
service.interceptors.response.use(
  response => {
    const { config } = response;
    if (response.data.code == 200) {
      return response.data;
    } else {
      if (
        response.data.code == 401 &&
        (config.url !== "/api-uaa/oauth/user/reg/token/phone2" ||
          config.url !== "/api-uaa/oauth/user/reg/token/phoneTwin")
      ) {
        // MessageBox.alert('请重新登录', '登录失效', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     window.location.reload();
        //     router.replace('/login')
        //   }
        // });
        localStorage.clear();
        location.reload();
      }
    }
    return response.data;
  },
  error => {
    if (error.response.status === 1) {
      Message({
        message: "该账号已到期，请联系管理员",
        type: "error",
        duration: 3 * 1000
      });
      localStorage.clear();
      location.reload();
    } else if (error.response.status === 401) {
      Message({
        message: "token 过期, 请重新登录",
        type: "error",
        duration: 3 * 1000
      });
      localStorage.clear();
      location.reload();
    } else {
      Message({
        message: error.response.data.msg ? error.response.data.msg : "请求错误",
        type: "error",
        duration: 3 * 1000
      });
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js